/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnswerSubmissionsRequest } from '../models/AnswerSubmissionsRequest';
import type { GetTasterExperimentNextProductsResponse } from '../models/GetTasterExperimentNextProductsResponse';
import type { GetTasterExperimentSummaryResponse } from '../models/GetTasterExperimentSummaryResponse';
import type { GetTasterPreferenceQuestionnaire } from '../models/GetTasterPreferenceQuestionnaire';
import type { PostTasterPreferenceQuestionnaireAnswer } from '../models/PostTasterPreferenceQuestionnaireAnswer';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TasterExperimentsService {

    /**
     * Read Experiments
     * @param onlyJoined
     * @returns GetTasterExperimentSummaryResponse Successful Response
     * @throws ApiError
     */
    public static readExperimentsV1TasterExperimentsGet(
        onlyJoined?: (boolean | null),
    ): CancelablePromise<Array<GetTasterExperimentSummaryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/taster-experiments/',
            query: {
                'only_joined': onlyJoined,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Join Experiment
     * @param experimentId
     * @returns void
     * @throws ApiError
     */
    public static joinExperimentV1TasterExperimentsPost(
        experimentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/taster-experiments/',
            query: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Accept Experiment
     * @param experimentId
     * @returns void
     * @throws ApiError
     */
    public static acceptExperimentV1TasterExperimentsAcceptPost(
        experimentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/taster-experiments/accept',
            query: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Decline Experiment
     * @param experimentId
     * @returns void
     * @throws ApiError
     */
    public static declineExperimentV1TasterExperimentsDeclinePost(
        experimentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/taster-experiments/decline',
            query: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Leave Experiment
     * @param experimentId
     * @returns void
     * @throws ApiError
     */
    public static leaveExperimentV1TasterExperimentsExperimentIdDelete(
        experimentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/taster-experiments/{experiment_id}',
            path: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read Preferences
     * @returns GetTasterPreferenceQuestionnaire Successful Response
     * @throws ApiError
     */
    public static readPreferencesV1TasterExperimentsPreferencesTasterIdGet(): CancelablePromise<GetTasterPreferenceQuestionnaire> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/taster-experiments/preferences/{taster_id}',
        });
    }

    /**
     * Update Preferences
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updatePreferencesV1TasterExperimentsPreferencesPut(
        requestBody: Array<PostTasterPreferenceQuestionnaireAnswer>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/taster-experiments/preferences',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit Answers
     * @param experimentId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static submitAnswersV1TasterExperimentsSubmitExperimentIdPost(
        experimentId: string,
        requestBody: AnswerSubmissionsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/taster-experiments/submit/{experiment_id}',
            path: {
                'experiment_id': experimentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Next Products
     * @param experimentId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getNextProductsV1TasterExperimentsNextProductsExperimentIdGet(
        experimentId: string,
    ): CancelablePromise<(GetTasterExperimentNextProductsResponse | string | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/taster-experiments/next-products/{experiment_id}',
            path: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Ask For Help
     * @param experimentId
     * @returns void
     * @throws ApiError
     */
    public static askForHelpV1TasterExperimentsAskForHelpExperimentIdPost(
        experimentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/taster-experiments/ask-for-help/{experiment_id}',
            path: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Cancel Help
     * @param experimentId
     * @returns void
     * @throws ApiError
     */
    public static cancelHelpV1TasterExperimentsCancelHelpExperimentIdPost(
        experimentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/taster-experiments/cancel-help/{experiment_id}',
            path: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Rounds State
     * @param experimentId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getRoundsStateV1TasterExperimentsRoundsStateExperimentIdGet(
        experimentId: string,
    ): CancelablePromise<(Record<string, number> | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/taster-experiments/rounds-state/{experiment_id}',
            path: {
                'experiment_id': experimentId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
